import React from 'react';

const PrivacyPolicy = ()  => (
    <div className="container">
        <div className="hr"></div>
        <div className="row">
            <div className="col-12">
                <h1 className="page-title-master">Privacy Policy</h1>
                <p><strong>Last Updated:</strong> August 27, 2025</p>
            </div>
        </div>
        <div className="page_header_full">
            <div className="page_title_header"></div>
        </div>

        <div id="float_left">	
            <div className="text_with_image_on_right_2">
                <p>
                    At <strong>CapitalTrends</strong> ("we," "our," or "us"), we respect your privacy and are
                    committed to protecting your personal information. This Privacy Policy explains how we
                    collect, use, and safeguard your data when you use our website
                    <a href="https://capitaltrends.in" target="_blank" rel="noopener noreferrer"> https://capitaltrends.in </a>
                    and related services.
                </p>

                <p><strong>1. Information We Collect</strong></p>
                <ul>
                    <li>
                    <strong>Personal Information:</strong> Your name and email address when you subscribe to our
                    updates, newsletters, or contact us.
                    </li>
                    <li>
                    <strong>Non-Personal Information:</strong> Browser type, device information, and website usage
                    data collected via analytics or similar tools.
                    </li>
                </ul>


                <p><strong>2. How We Use Your Information</strong></p>
                    <ul>
                        <li>To send newsletters, updates, and communications related to our services.</li>
                        <li>To improve our website and services.</li>
                        <li>To respond to inquiries and provide customer support.</li>
                    </ul>
                <p>
                    We do <strong>not</strong> sell, rent, or trade your personal information with third parties.
                </p>

                <p><strong>3. Third-Party Services</strong></p>
                <p>
                    We may share your information with trusted third-party service providers that help us operate
                    our business, including:
                </p>
                <ul>
                    <li>
                    <strong>Mailgun</strong> – used for sending emails and newsletters. These providers process your
                    data on our behalf in accordance with their own privacy policies and applicable laws.
                    </li>
                </ul>

                <p><strong>4. Data Security</strong></p>
                <p>
                    We take reasonable measures to protect your personal information against unauthorized access,
                    alteration, disclosure, or destruction. However, no method of transmission over the Internet is
                    100% secure, and we cannot guarantee absolute security.
                </p>

                <p><strong>5. Your Rights &amp; Choices</strong></p>
                <ul>
                    <li>
                        You can unsubscribe from our emails at any time using the link provided in each message.
                    </li>
                    <li>
                        You may request access, correction, or deletion of your personal information by contacting us.
                    </li>
                </ul>

                <p><strong>6. Changes to This Policy</strong></p>
                <p>
                    We may update this Privacy Policy from time to time. Any changes will be posted on this page
                    with a revised “Last Updated” date.
                </p>

                <p><strong>7. Contact Us</strong></p>
                <p>
                    If you have questions or concerns about this Privacy Policy, please contact us at:
                </p>
                <p>
                    <strong>Email:</strong> <a href="mailto:help@capitaltrends.in">help@capitaltrends.in</a>
                </p>
            </div>
        </div>
    </div>
);
  
export default PrivacyPolicy;